(function () {
    // week: 8:30 to 18:00 
    // weekend: 11:00 to 17:30 

    var CustomerServiceMessageContainer = document.querySelector('.js-customer-service-basket-message');
    var DateObject = new Date();
    var CurrentHours = DateObject.getHours();
    var CurrentMinutes = DateObject.getMinutes();
    var CustomerServiceAvailable = false;
    const dayOfWeek = DateObject.getDay();
    const isWeekend = (dayOfWeek === 6) || (dayOfWeek  === 0);

    if (CustomerServiceMessageContainer) {
        var CustomerServiceMessageAvailable = CustomerServiceMessageContainer.querySelector('.js-customer-service-available');
        var CustomerServiceMessageUnavailable = CustomerServiceMessageContainer.querySelector('.js-customer-service-unavailable');
        
        if (
            CustomerServiceMessageAvailable &&
            CustomerServiceMessageUnavailable
        ) {
            
            if (isWeekend) {
                if (CurrentHours >= 11) {
                    if (CurrentHours == 11) {
                        CustomerServiceAvailable = true;
                    }
                    else {
                        CustomerServiceAvailable = true;
                    }

                    if (CurrentHours <= 17) {
                        if (CurrentHours == 17) {
                            CustomerServiceAvailable = true;
                            if (CurrentMinutes >= 30) {
                                CustomerServiceAvailable = true;
                            } else {
                                CustomerServiceAvailable = false;
                            }
                        }
                        else {
                            CustomerServiceAvailable = true;
                        }
                    } 
                    else {
                        CustomerServiceAvailable = false;
                    }
                }
            } 
            else {
                if (CurrentHours >= 8) {
                    if (CurrentHours == 8) {
                        if (CurrentMinutes >= 30) {
                            CustomerServiceAvailable = true;
                        } else {
                            CustomerServiceAvailable = false;
                        }
                    }
                    else {
                        CustomerServiceAvailable = true;
                    }
    
                    if (CurrentHours <= 18) {
                        if (CurrentHours == 18) {
                            CustomerServiceAvailable = true;

                            if (CurrentMinutes > 0) {
                                CustomerServiceAvailable = false;
                            }
                        }
                        else {
                            CustomerServiceAvailable = true;
                        }
                    } 
                    else {
                        CustomerServiceAvailable = false;
                    }
                }
            }
        }

        if (CustomerServiceAvailable) {
            CustomerServiceMessageAvailable?.classList.remove('hidden');
            CustomerServiceMessageUnavailable?.classList.add('hidden');
        } else {
            CustomerServiceMessageAvailable?.classList.add('hidden');
            CustomerServiceMessageUnavailable?.classList.remove('hidden');
        }
    }
})();
